import React from 'react';
import { connect } from 'react-redux';
import Spin from '../../components/loading';
import * as changePasswordActions from '../../redux/changePassword/actions';
import { formatter, domManipulator } from '../../utils';
import FailedMessagesList from '../../components/failedMesasgesList';
import './changePassword.scss';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';
import enums from '../../enums';
class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: locales('errors.default'),
      errorFlag: false,
      newPassword: '',
      repeatNewPassword: '',
      alertColor: 'error',
      oldPassword: '',
      oldPasswordInputInvalidMessage: '',
      oldPasswordInputValidateStatus: '',
      newPasswordInputValidateStatus: '',
      newPasswordInputValidateStatus: '',
      repeatNewPasswordInputValidateStatus: '',
      repeatNewPasswordInputValidateStatus: '',
      passwordSameChecker: true,
      passwordIsRequired: false
    };
  }

  handleAlert = () => {
    AlertAndConfirmation({ title: '', text: this.state.errorText, type: this.state.alertColor });
    this.setState({ errorFlag: false });
  };

  // alertAndConfirmation = () => {
  //   setTimeout(() => this.setState({ errorFlag: false }), 2000)
  //   return <div className={`alert ${this.state.alertColor}`}>
  //     {this.state.errorText}
  //   </div>
  // };
  onInputChanged = event => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
      errorFlag: false,
      oldPasswordInputInvalidMessage: '',
      oldPasswordInputValidateStatus: '',
      newPasswordInputValidateStatus: '',
      newPasswordInputValidateStatus: '',
      repeatNewPasswordInputValidateStatus: '',
      repeatNewPasswordInputValidateStatus: ''
    });
  };
  validateForm = () => {
    return new Promise((resolve, reject) => {
      const formattedOldPassword = formatter.toStandard(this.state.oldPassword);
      const formattedNewPassword = formatter.toStandard(this.state.newPassword);
      const formattedRepeatNewPassword = formatter.toStandard(this.state.repeatNewPassword);
      let isOldPasswordValid,
        isNewPasswordValid,
        isRepeatNewPasswordValid,
        firstErrorElementId = '',
        errors = {};

      if (!formattedOldPassword) {
        errors.oldPasswordInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('titles.oldPassword')
        });
        errors.oldPasswordInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'oldPassword';
        isOldPasswordValid = false;
      } else {
        errors.oldPasswordInputInvalidMessage = '';
        errors.oldPasswordInputValidateStatus = '';
        isOldPasswordValid = true;
      }

      if (!formattedNewPassword) {
        errors.newPasswordInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('titles.newPassword')
        });
        errors.newPasswordInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'newPassword';
        isNewPasswordValid = false;
      } else {
        errors.newPasswordInputInvalidMessage = '';
        errors.newPasswordInputInvalidMessage = '';
        isNewPasswordValid = true;
      }

      if (!formattedRepeatNewPassword) {
        errors.repeatNewPasswordInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('titles.repeatNewPassword')
        });
        errors.repeatNewPasswordInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'repeatNewPassword';
        isRepeatNewPasswordValid = false;
      } else {
        errors.repeatNewPasswordInputInvalidMessage = '';
        errors.repeatNewPasswordInputValidateStatus = '';
        isRepeatNewPasswordValid = true;
      }

      if (formattedRepeatNewPassword !== formattedNewPassword) {
        this.setState({ errorFlag: true, errorText: locales('alerts.PasswordsNotMatch') });
      }

      let isFormValid =
        isOldPasswordValid &&
        isNewPasswordValid &&
        isRepeatNewPasswordValid &&
        formattedNewPassword === formattedRepeatNewPassword;

      if (!isFormValid) {
        this.setState(
          () => ({
            ...errors
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  };
  onFormSubmit = async () => {
    const isFormValid = await this.validateForm();
    if (!isFormValid) return;
    let { oldPassword, newPassword } = this.state;
    this.props.changePassword(oldPassword, newPassword).then(res => {
      if (!Object.entries(res.payload).length) {
        this.setState({
          errorFlag: true,
          alertColor: 'success',
          errorText: locales('titles.passwordSuccessfullyChanged')
        });
      } else {
        this.setState({ alertColor: 'error', errorFlag: true });
      }
    });
  };
  render() {
    let {
      oldPassword,
      repeatNewPassword,
      newPassword,
      oldPasswordInputValidateStatus,
      newPasswordInputValidateStatus,
      repeatNewPasswordInputValidateStatus
    } = this.state;
    let { loading, message, failed, error } = this.props;
    return (
      <>
        {/* design completed */}
        {this.state.errorFlag && this.handleAlert()}
        <section className="p-1 col-12 my-2">
          <section className="col-12 d-flex justify-content-between">
            <h3 className="text-muted py-4">
              <div className="text-right">{locales('titles.changePassword')}</div>
            </h3>
            <div className="d-flex align-items-center col-8 justify-content-end">
              <button
                className="btn btn-success changePasswordSubmitButton w-5"
                onClick={event => {
                  event.preventDefault();
                  this.onFormSubmit();
                }}
              >
                <i className="fa fa-save" />
                {locales('labels.save')}
                {/* 16811681 */}
              </button>
            </div>
          </section>
          <Spin spinning={loading}>
            <article>
              {error ? (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              ) : (
                <>
                  {failed ? (
                    this.props.changePasswordMessages && this.props.changePasswordMessages.length ? (
                      <FailedMessagesList
                        className="errors-list"
                        messagesList={this.props.changePasswordMessages}
                      />
                    ) : (
                      <div className="alert alert-danger">{message}</div>
                    )
                  ) : null}
                  <form autoComplete="off" className="panel panel-default">
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.changePasswordForm')}
                    </div>
                    <div className="panel-body">
                      <div className="col-12 my-2">
                        <input
                          id="oldPassword"
                          name="oldPassword"
                          type="password"
                          placeholder={locales('titles.oldPassword')}
                          className={`form-control ${oldPasswordInputValidateStatus}`}
                          onChange={event => this.onInputChanged(event)}
                          autoComplete="off"
                          value={oldPassword}
                          maxLength={enums.MAX_LENGTH.password}
                        />
                        <small style={{ color: '#ccc' }}>{locales('maxLength.15')}</small>
                        <div className="invalid-feedback">{this.state.oldPasswordInputInvalidMessage}</div>
                      </div>
                      <div className="col-12 my-2">
                        <input
                          id="newPassword"
                          name="newPassword"
                          placeholder={locales('titles.newPassword')}
                          type="password"
                          className={`form-control ${newPasswordInputValidateStatus}`}
                          onChange={event => this.onInputChanged(event)}
                          autoComplete="off"
                          value={newPassword}
                          maxLength={enums.MAX_LENGTH.password}
                        />
                        <small style={{ color: '#ccc' }}>{locales('maxLength.15')}</small>
                        <div className="invalid-feedback">{this.state.newPasswordInputInvalidMessage}</div>
                      </div>
                      <div className="col-12 my-2">
                        <input
                          id="repeatNewPassword"
                          name="repeatNewPassword"
                          placeholder={locales('titles.repeatNewPassword')}
                          type="password"
                          className={`form-control ${repeatNewPasswordInputValidateStatus}`}
                          onChange={event => this.onInputChanged(event)}
                          autoComplete="off"
                          value={repeatNewPassword}
                          maxLength={enums.MAX_LENGTH.password}
                        />
                        <small style={{ color: '#ccc' }}>{locales('maxLength.15')}</small>
                        <div className="invalid-feedback">
                          {this.state.repeatNewPasswordInputInvalidMessage}
                        </div>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </article>
          </Spin>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.changePasswordReducer.changePasswordLoading,
    message: state.changePasswordReducer.changePasswordMessage,
    changePasswordMessages: state.changePasswordReducer.changePasswordMessages,
    failed: state.changePasswordReducer.changePasswordFailed,
    error: state.changePasswordReducer.changePasswordError,
    changePasswordStatus: state.changePasswordReducer.changePasswordStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changePassword: (oldPassword, newPassword) =>
      dispatch(changePasswordActions.changePassword(oldPassword, newPassword))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
